module.exports = __webpack_public_path__ + "ship2.jpg?d28313eaef324b2148c6140a903f441b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ship2.jpg
// module id = 1576
// module chunks = 0